<template>
  <div>
    <Headersys />
    <div class="content">
      <div class="realy-content">
        <div class="qrCode-box" id="idcard">
          <div class="sfz-box">
            <img
              class="sfz-img-bg"
              src="@/assets/images/idcard-index.png"
              alt=""
            />
            <div class="user-name posi">{{ idcard.Name }}</div>
            <div class="user-sex posi">{{ idcard.Sex }}</div>
            <div class="user-nati posi">{{ idcard.Nation }}</div>
            <div class="user-Y posi">{{ idcard.Birthday.slice(0, 4) }}</div>
            <div class="user-M posi">{{ idcard.Birthday.slice(4, 6) }}</div>
            <div class="user-D posi">{{ idcard.Birthday.slice(6, 8) }}</div>
            <div class="user-address posi">{{ idcard.Address }}</div>
            <div class="user-cerno posi">{{ idcard.IDNumber }}</div>
            <img class="user-avatar posi" :src="avatar" alt="12" />
          </div>
          <div class="sfz-box">
            <img class="sfz-img-bg" src="@/assets/images/idcard.png" alt="" />
            <div class="user-IDIssued posi">{{ idcard.IDIssued }}</div>
            <div class="user-periodTime posi">{{ idcard.periodTime }}</div>
          </div>
          <div style="width: 100%; height: 35rem"></div>
        </div>
      </div>
      <div class="load-mask" id="loadDom" v-if="maskShow"></div>
    </div>
    <Back :print="print" @toPrintEve="printPdfFile" />
  </div>
</template>
<script>
import lodop from "@/assets/js/doPrint.js";
import { Loading } from "element-ui";
import domtoimage from "dom-to-image";

export default {
  name: "",
  data() {
    return {
      idcard: {},
      loadingInstance: null,
      waitTime: 180,
      watiTimer: null,
      print: "2", //打印按钮
      avatar: "",
      maskShow: false,
      fmac: "",
      name: "",
      phone: "",
      idCard: "",
    };
  },
  created() {
    this.idcard = this.$store.state.idcardInfo;
    // 有效期
    this.idcard.periodTime = this.validityPeriod(
      this.idcard.UserLifeBegin,
      this.idcard.UserLifeEnd
    );
    this.touMing(this.idcard.Base64Photo, (evt) => {
      this.avatar = evt;
    });
  },
  mounted() {
    this.timeDown();
    this.$fun.getMAC((mac) => {
      this.fmac = mac;
      // var userInfo = JSON.parse(localStorage.getItem('USERINFO'))
    });
    var userInfo = this.$store.state.suerInfo;
    this.name = userInfo.name;
    this.phone = userInfo.tel;
    this.idCard = userInfo.cerno;
  },
  destroyed() {
    clearTimeout(this.watiTimer);
  },
  methods: {
    generateIMG() {
      console.log("开始生成");
      var node = document.getElementById("idcard");
      var _this = this;
      // 先用domtoimage获取到HTML转化后图片后，已base64方式保存
      domtoimage.toPng(node).then(function (dataUrl) {
        // "data:image/png;base64,"
        dataUrl = dataUrl.replace("data:image/png;base64,", "");
        // console.log(dataUrl);
        _this.localPrint(dataUrl);
      });
    },
    localPrint(base64String) {
      this.$rqt.localhost_print({
        base64String,
      });
    },
    // 倒计时
    timeDown() {
      this.watiTimer = setInterval(() => {
        if (this.waitTime > 1) {
          this.waitTime--;
        } else {
          this.waitTime = 180;
          clearInterval(this.watiTimer);
          this.$router.replace("/");
        }
      }, 1000);
    },
    printPdfFile() {
      this.$rqt.print_save({
        type: "身份证复印",
        fmac: this.fmac,
        name: this.name,
        phone: this.phone,
        idCard: this.idCard,
      });
      this.maskShow = true;
      setTimeout(() => {
        this.loadingInstance = Loading.service({
          fullscreen: true,
          text: "正在打印...",
          target: document.querySelector("#loadDom"),
        });
      }, 500);
      setTimeout(() => {
        this.loadingInstance.close();
        this.maskShow = false;
      }, 16000);
      this.generateIMG();
      // lodop.idcardPrint(this.idcard, this.avatar)
      // this.loadingInstance = Loading.service({ fullscreen: true, text: '正在打印...', target: document.querySelector('#loadDom') });
      // setTimeout(() => {
      //   this.loadingInstance.close();
      // }, 16000);
    },
    // 有效期限
    validityPeriod(time1, time2) {
      return (
        time1.slice(0, 4) +
        "." +
        time1.slice(4, 6) +
        "." +
        time1.slice(6, 8) +
        "-" +
        time2.slice(0, 4) +
        "." +
        time2.slice(4, 6) +
        "." +
        time2.slice(6, 8)
      );
    },
    touMing(Base64Photo, callback) {
      let self = this;
      var canvas = document.createElement("canvas");
      var context = canvas.getContext("2d");
      // 创建新图片
      var img = new Image();
      // img.src = "data:image/bmp;base64," + Base64Photo;
      img.src = Base64Photo;
      img.addEventListener(
        "load",
        function () {
          // 绘制图片到canvas上
          canvas.width = img.width;
          canvas.height = img.height;
          context.drawImage(img, 0, 0);

          // 将canvas的透明背景设置成白色
          var imageData = context.getImageData(
            0,
            0,
            canvas.width,
            canvas.height
          );
          for (var i = 0; i < imageData.data.length; i += 4) {
            //rgb大于250的透明度y均设置成0
            if (
              imageData.data[i] > 250 &&
              imageData.data[i + 1] > 250 &&
              imageData.data[i + 2] > 250
            ) {
              imageData.data[i + 3] = 0;
            }
          }
          context.putImageData(imageData, 0, 0);
          self.baseImg = canvas.toDataURL("image/png").slice(22); //返回base64
          if (typeof callback !== undefined) {
            if (callback) callback("data:image/png;base64," + self.baseImg);
          }
        },
        false
      );
    },
  },
};
</script>
<style scoped lang="scss">
.content {
  width: 70%;
  height: calc(100vh - 42rem - 40px);
  padding: 20px;
  margin: auto;
  background-color: #fff;
  // overflow: scroll;
  position: relative;
}

// .content::-webkit-scrollbar {
//   display: none;
//   /* 对于Chrome, Safari和Opera */
// }
.realy-content {
  width: 100%;
  height: calc(100vh - 42rem - 40px);
  overflow: scroll;
}

.realy-content::-webkit-scrollbar {
  display: none;
  /* 对于Chrome, Safari和Opera */
}

.qrCode-box {
  margin: auto;
  // text-align: center;
}

// .idCard-img {
//   width: 180rem;
//   margin-bottom: 2rem;
// }
.sfz-box {
  width: fit-content;
  margin: 0 auto 30px;
  position: relative;
}

.sfz-img-bg {
  width: 132rem;
}

.posi {
  position: absolute;
  font-size: 4.5rem;
}

.user-name {
  top: 10.2rem;
  left: 25rem;
  font-size: 5rem;
  width: 500px;
}

.user-sex {
  top: 21rem;
  left: 25rem;
}

.user-nati {
  width: 25rem;
  top: 21rem;
  left: 52rem;
}

.user-Y {
  width: 10rem;
  top: 31.5rem;
  left: 26rem;
  text-align: center;
}

.user-M {
  width: 8rem;
  top: 31.5rem;
  left: 43rem;
  text-align: center;
}

.user-D {
  width: 8rem;
  top: 31.5rem;
  left: 54rem;
  text-align: center;
}

.user-address {
  top: 42rem;
  left: 25rem;
  // background-color: red;
  width: 45rem;
}

.user-cerno {
  top: 68rem;
  left: 43rem;
  letter-spacing: 1rem;
  font-weight: bold;
}

.user-avatar {
  width: 35rem;
  height: 45rem;
  display: block;
  top: 13rem;
  left: 83rem;
  // background-color: red;
}

.user-IDIssued {
  top: 59.5rem;
  left: 52rem;
  font-size: 4rem;
}

.user-periodTime {
  top: 69.5rem;
  left: 52rem;
  font-size: 4rem;
}

.load-mask {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
</style>
